import { useEffect, useRef } from 'react';

const usePrevious = <T>(value: T) => {
  const previous = useRef<T>(null);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    previous.current = value;
  });

  return previous.current;
};

export default usePrevious;
